// import img1 from './img/img1.png'
// import img2 from './img/img2.png'
// import img3 from './img/img3.png'

const data = {
  productData:[
    {
      id:1,
      img: 'https://i.pinimg.com/originals/ef/61/95/ef6195bfa842d5aca8d240be5f3a0f7c.jpg',
      title: 'Abacate',
      desc: '',
      price: 10,
    },
    {
      id:2,
      img: 'https://www.costadosauipe.com.br/images/news/0252/frutas-da-bahia-topo.jpg',
      title: 'Pera',
      desc: '',
      price: 5,
    },
    {
      id:3,
      img: 'https://estado.rs.gov.br/upload/recortes/201802/21164308_1438040_GDO.jpg',
      title: 'Mamão',
      desc: '',
      price: 25,
    },
  ]
}

export default data